import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "./../axios";
import { newAlert } from "./alertSlice";
import { showModal, showSpinner } from "./sessionSlice";
import moment from "moment";

//#region getDshboardByTimeperiod
export const getDashboardByTimePeriod = createAsyncThunk(
  "orgAdmin/getDashboarbByTimePeriod",
  async (payload, thunkApi) => {
    try {
      const { toDate, fromDate, timezone } = payload;
      console.log("payload", payload);
      const { data } = await Axios.get(
        `/api/orgAdmin/get-dashboard-by-timeperiod?toDate=${toDate}&fromDate=${fromDate}&timezone=${timezone}`
      );
      return data.dashboard;
    } catch (error) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "Server Error" }));
      return Promise.reject({ error: { message: error.message } });
    }
  }
);
//#endregion

//#region updateCandidateData
export const updateCandidateData = createAsyncThunk(
  "orgAdmin/updateCandidateData",
  async (payload, thunkApi) => {
    try {
      const { supervisors } = payload;

      const { data } = await Axios.post(`/api/orgAdmin/update-candidate-data`, {
        ...payload,
        supervisors: supervisors.map((supervisor) => supervisor._id),
      });
      if (data.isCandidateDataUpdated) {
        thunkApi.dispatch(showSpinner(null));
        thunkApi.dispatch(
          newAlert({ type: "success", message: "Update Successfull" })
        );
        thunkApi.dispatch(showModal(null));
        return payload;
      } else {
        thunkApi.dispatch(showSpinner(null));
        thunkApi.dispatch(
          newAlert({ type: "danger", message: "Server Error" })
        );
        throw new Error("Update Failed");
      }
    } catch (error) {
      thunkApi.dispatch(showSpinner(null));
      thunkApi.dispatch(newAlert({ type: "danger", message: "Server Error" }));
      return Promise.reject({ error: { message: error.message } });
    }
  }
);
//#endregion

//#region createProject
export const createProject = createAsyncThunk(
  "orgAdmin/createProject",
  async (payload, thunkApi) => {
    try {
      const { clientId, candidates, projectName } = payload;
      const candidateIds = candidates.map((candidate) => candidate._id);
      const postBody = {
        candidateIds,
        projectName,
      };
      const { data } = await Axios.post(
        `/api/orgAdmin/create-project`,
        postBody
      );
      if (data.isProjectCreated) {
        thunkApi.dispatch(showSpinner(null));
        thunkApi.dispatch(showModal(null));
        thunkApi.dispatch(
          newAlert({ type: "success", message: "Project Created Successfully" })
        );
        thunkApi.dispatch(getProjectAssignmentView());
      } else {
        thunkApi.dispatch(showSpinner(null));
        thunkApi.dispatch(
          newAlert({ type: "danger", message: "server error" })
        );
      }
      return data;
    } catch (error) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "server error" }));
      thunkApi.dispatch(showSpinner(null));
      return Promise.reject({ error: { message: error.message } });
    }
  }
);
// #endregion
//#region getCandidateList
export const getCandidateList = createAsyncThunk(
  "orgAdmin/getCandidateList",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.get(
        `/api/orgAdmin/search-candidates?query=${null}&&selectAllCandidates=${true}`
      );
      return data.result;
    } catch (error) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "Server Error" }));
      return Promise.reject({ error: { message: error.message } });
    }
  }
);
//#endregion

//#region getReport
export const getReport = createAsyncThunk(
  "orgAdmin/getReport",
  async (payload, thunkApi) => {
    try {
      const { candidates, toDate, fromDate, timezone, clientId } = payload;
      console.log("payload", payload);
      let candidateIds = candidates.map((candidate) => candidate._id);
      const { data } = await Axios.get(
        `/api/orgAdmin/getReport?candidates=${candidateIds}&&toDate=${toDate}&&fromDate=${fromDate}&&timezone=${timezone}&clientId=${clientId}`
      );
      return data;
    } catch (error) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "Server Error" }));
      return Promise.reject({ error: { message: error.message } });
    }
  }
);
//#endregion

//#region edit Project
export const editProject = createAsyncThunk(
  "orgAdmin/editProject",
  async (payload, thunkApi) => {
    try {
      const { candidates, projectName, projectId } = payload;
      const candidateIds = candidates.map((candidate) => candidate._id);
      console.log("payload", payload);
      const postBody = {
        candidateIds,
        projectName,
        projectId,
      };
      const { data } = await Axios.put(`/api/orgAdmin/edit-project`, postBody);
      if (data.isProjectUpdated) {
        thunkApi.dispatch(showSpinner(null));
        thunkApi.dispatch(showModal(null));
        thunkApi.dispatch(
          newAlert({ type: "success", message: "Project edited Successfully" })
        );
      } else {
        thunkApi.dispatch(showSpinner(null));
        thunkApi.dispatch(
          newAlert({ type: "danger", message: "server error" })
        );
      }
      return data;
    } catch (error) {
      thunkApi.dispatch(showSpinner(null));
      return Promise.reject({ error: { message: error.message } });
    }
  }
);
// #endregion

// #region Edit Candidate
export const editCandidate = createAsyncThunk(
  "admin/editCandidate",
  async (payload, thunkAPI) => {
    try {
      console.log(payload, "orgAdminEditCandidate");
      const dataToBeSend = {
        candidateId: payload.candidateId,
        role: payload.role,
      };
      if (payload.candidatesSupervising) {
        dataToBeSend.candidatesSupervising = payload.candidatesSupervising.map(
          (candidate) => candidate._id
        );
      }
      if (payload.position) {
        dataToBeSend.position = payload.position;
      }
      if (payload.supervisors) {
        dataToBeSend.supervisors = payload.supervisors.map(
          (candidate) => candidate._id
        );
      }
      const { data } = await Axios.put(
        `/api/generic/edit-candidate`,
        dataToBeSend
      );
      if (!data.isCandidateEdited) {
        return thunkAPI.dispatch(
          newAlert({
            type: "danger",
            message: data.error,
          })
        );
      } else {
        thunkAPI.dispatch(
          newAlert({
            type: "success",
            message: "User Data Changed Successfully",
          })
        );
      }
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(showModal(null));
      return payload;
    } catch (err) {
      thunkAPI.dispatch(showSpinner(null));
      thunkAPI.dispatch(
        newAlert({
          type: "danger",
          message: err.message,
        })
      );
      console.error("Error in edit user :- ", err.message);
      return Promise.reject(err);
    }
  }
);
// #endregion

// #region Get Project Assignment view
export const getProjectAssignmentView = createAsyncThunk(
  "/orgAdmin/getProjectAssignmentView",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.get("/api/orgAdmin/project-assignment-view");
      thunkApi.dispatch(getTaskList());
      return data;
    } catch (err) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "server error" }));
      return thunkApi.rejectWithValue();
    }
  }
);
// #endregion

// #region Get Task List
export const getTaskList = createAsyncThunk(
  "/generic/get-tasks",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.get("/api/generic/get-tasks");
      return data;
    } catch (err) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "server error" }));
      return thunkApi.rejectWithValue();
    }
  }
);
// #endregion

// #region save defaults
export const saveDefaults = createAsyncThunk(
  "/orgAdmin/save-defaults",
  async (payload, thunkApi) => {
    try {
      const { data } = await Axios.put("/api/orgAdmin/save-defaults", payload);
      if (data.success) {
        thunkApi.dispatch(
          newAlert({
            type: "success",
            message: "Default Project and Task saved",
          })
        );
      }
      return data;
    } catch (err) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "server error" }));
      return thunkApi.rejectWithValue();
    } finally {
      thunkApi.dispatch(showSpinner(null));
    }
  }
);
// #endregion

// #region save project data
export const saveProjectData = createAsyncThunk(
  "/orgAdmin/save-project-data",
  async (payload, thunkApi) => {
    try {
      console.log("payload :- ", payload);

      const { data } = await Axios.put(
        "/api/orgAdmin/save-project-data",
        payload
      );
      thunkApi.dispatch(
        newAlert({ type: "success", message: "changes are saved" })
      );

      return data;
    } catch (err) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "server error" }));
      return thunkApi.rejectWithValue();
    } finally {
      thunkApi.dispatch(showSpinner(null));
    }
  }
);
// #endregion

export const orgAdminSlice = createSlice({
  name: "orgAdmin",
  initialState: {
    selectedDate: moment().toISOString(),
    dashboard: [],
    loading: true,
    candidates: [],
    report: [],
    defaultProject: [],
    defaultTask: [],
    projectData: [],
    taskList: [],
    projectNames: [],
    projectMembers: [],
    members: [],
  },
  reducers: {
    //  change default Task
    setDefaultProject: (state, action) => {
      state.defaultProject = action.payload;
    },
    setDefaultTask: (state, action) => {
      state.defaultTask = action.payload;
    },
    changeProjectName: (state, { payload }) => {
      state.projectNames = state.projectNames.map((item) => {
        if (payload._id === item._id) {
          return { ...item, newName: payload.value };
        }
        return item;
      });
    },
    changeProjectMembers: (state, { payload }) => {
      state.projectMembers = state.projectMembers.map((item) => {
        if (item._id === payload.projectId) {
          return { ...item, members: payload.val };
        } else {
          return item;
        }
      });
    },
  },
  extraReducers: {
    //#region getDashboardByTimePeriod
    [getDashboardByTimePeriod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.dashboard = payload;
    },
    [getDashboardByTimePeriod.rejected]: (state) => {
      state.loading = false;
    },
    [getDashboardByTimePeriod.pending]: (state) => {
      state.loading = true;
    },
    //#endregion

    //#region getDashboardByTimePeriod
    [updateCandidateData.fulfilled]: (state, { payload }) => {
      let updatedDashboard = state.dashboard;
      updatedDashboard = updatedDashboard.map((data) => {
        if (data.candidateId === payload.candidateId) {
          data.supervisors = payload.supervisors;
        }
        return data;
      });
      state.dashboard = updatedDashboard;
    },
    [updateCandidateData.rejected]: () => {},
    [updateCandidateData.pending]: () => {},
    //#endregion

    //#region getCandidateList
    [getCandidateList.fulfilled]: (state, { payload }) => {
      state.candidates = payload;
    },
    [getCandidateList.rejected]: () => {},
    [getCandidateList.pending]: () => {},
    //#endregion

    //#region getReport
    [getReport.fulfilled]: (state, { payload }) => {
      state.report = payload.reportData;
    },
    [getReport.rejected]: () => {},
    [getReport.pending]: () => {},
    //#endregion
    //#region editCandidate
    [editCandidate.fulfilled]: (state, { payload }) => {
      let updatedDashboard = state.dashboard;
      updatedDashboard = updatedDashboard.map((data) => {
        if (data.candidateId === payload.candidateId) {
          if (payload.supervisors) {
            data.supervisors = payload.supervisors;
          }
          if (payload.position) {
            data.position = payload.position;
          }
          if (payload.candidatesSupervising) {
            data.candidatesSupervising = payload.candidatesSupervising;
          }
        }
        return data;
      });
      state.dashboard = updatedDashboard;
    },
    [editCandidate.rejected]: () => {},
    [editCandidate.pending]: () => {},
    //#endregion

    // #region orgAdmin Get Project View
    [getProjectAssignmentView.pending]: (state) => {
      state.isLoading = true;
    },
    [getProjectAssignmentView.fulfilled]: (state, { payload }) => {
      if (payload.defaultProject !== null) {
        state.defaultProject = [payload.defaultProject];
      } else {
        state.defaultProject = [];
      }

      if (payload.defaultTask !== null) {
        state.defaultTask = [payload.defaultTask];
      } else {
        state.defaultTask = [];
      }
      // project name
      state.projectNames = payload.projectData.map((item) => ({
        _id: item._id,
        oldName: item.name,
        newName: item.name,
      }));
      state.projectMembers = payload.projectData.map((item) => {
        const members = item.candidates.map((can) => {
          return {
            candidateId: can._id,
            fullName: `${can.candidate.firstName} ${can.candidate.lastName}`,
          };
        });
        return {
          _id: item._id,
          members: members,
          oldMembers: members,
        };
      });
      state.projectData = payload.projectData;
      state.members = payload.members.map((can) => {
        return {
          candidateId: can._id,
          fullName: `${can.candidate.firstName} ${can.candidate.lastName}`,
        };
      });
      state.isLoading = true;
    },
    [getProjectAssignmentView.rejected]: (state) => {
      state.isLoading = true;
    },
    // #endregion

    // #region Get Tasks
    [getTaskList.pending]: (state) => {
      state.loading = true;
    },
    [getTaskList.fulfilled]: (state, { payload }) => {
      state.taskList = payload;
    },
    [getTaskList.rejected]: () => {},
    // #endregion

    // #region save-defaults
    [saveDefaults.pending]: () => {},
    [saveDefaults.fulfilled]: () => {},
    [saveDefaults.rejected]: () => {},
    // #endregion

    // #region save project data
    [saveProjectData.pending]: () => {},
    [saveProjectData.fulfilled]: () => {},
    [saveProjectData.rejected]: () => {},
    // #endregion
  },
});

//#region Actions Export
export const {
  setDefaultProject,
  setDefaultTask,
  changeProjectName,
  changeProjectMembers,
} = orgAdminSlice.actions;

export default orgAdminSlice.reducer;
